"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

require("../../assets/css/components/form/CheckboxField.css");

var _Fields = require("./Fields");

var _Fields2 = _interopRequireDefault(_Fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxField = function (_React$Component) {
    _inherits(CheckboxField, _React$Component);

    function CheckboxField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CheckboxField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            var data = {
                checked: e.target.checked,
                type: e.target.type,
                name: e.target.name,
                disabled: e.target.disabled
            };
            _this.props.onChange(e, data);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CheckboxField, [{
        key: "getLabel",
        value: function getLabel() {
            if (this.props.rightLabel) return _react2.default.createElement(
                "label",
                { className: "mtd-checkbox-label", htmlFor: this.props.name },
                this.props.label
            );
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _Fields2.default,
                this.props,
                _react2.default.createElement(
                    "div",
                    { className: "mtd-checkbox " + (this.props.disabled ? 'disabled' : '') },
                    this.getLabel(),
                    _react2.default.createElement("input", { type: "checkbox", name: this.props.name, id: this.props.name, value: this.props.name, checked: this.props.value, onChange: this.onChange, disabled: this.props.disabled }),
                    _react2.default.createElement(
                        "div",
                        { className: "mtd-checkbox-box", "aria-hidden": "true" },
                        _react2.default.createElement("span", { className: "mtd-checkbox-border" }),
                        _react2.default.createElement("span", { className: "mtd-checkbox-focus" }),
                        _react2.default.createElement("span", { className: "mtd-checkbox-check" })
                    )
                )
            );
        }
    }]);

    return CheckboxField;
}(_react2.default.Component);

exports.default = CheckboxField;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/CheckboxField.js
// module id = 584
// module chunks = 0